// src/components/ui/mainScreen/FiltersCarousel.jsx
import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { useFilters } from '../../../utils/FilterContext';

import beachesIco from '../../../assets/icons/interface/beaches.svg';
import hotelIco from '../../../assets/icons/interface/hotel.svg';
import entertainmentIco from '../../../assets/icons/interface/entertainment.svg';
import bankCategoryIco from '../../../assets/icons/interface/bank.svg';
import societyIco from '../../../assets/icons/interface/society.svg';
import barIco from '../../../assets/icons/interface/bar.svg';
import fastfoodIco from '../../../assets/icons/interface/fastfood.svg';
import restaurantIco from '../../../assets/icons/interface/restaurant.svg';
import shopIco from '../../../assets/icons/interface/shop.svg';
import educationIco from '../../../assets/icons/interface/education.svg';
import estateIco from '../../../assets/icons/interface/estate.svg';
import otherIco from '../../../assets/icons/interface/other.svg';

const categoryNameMap = {
    beaches: "Beach Clubs",
    hotel: "Hotels",
    entertainment: "Entertaiments",
    bank: "Banks & ATM",
    society: "Society & Services",
    sport: "Sport, Health, Beauty",
    food: "Restaurants",
    // bar: "Бары",
    // fastfood: "Фастфуд",
    // restaurant: "Рестораны",
    shop: "Shops",
    education: "Education",
    estate: "Real Estate",
    other: "Addition",
};

const categoryIconMap = {
    beaches:     beachesIco,
    hotel:       hotelIco,
    entertainment: entertainmentIco,
    bank:        bankCategoryIco,
    society:     societyIco,
    bar:         barIco,
    fastfood:    fastfoodIco,
    restaurant:  restaurantIco,
    shop:        shopIco,
    education:   educationIco,
    estate:      estateIco,
    other:       otherIco
};

const FiltersCarousel = () => {
    const { CATEGORIES, activeFilters, selectFilter, resetFilters } = useFilters();
    const carouselRef = useRef(null);

    useEffect(() => {
        const el = carouselRef.current;
        if (!el) return;
        // Отключаем Leaflet-овские события на этом элементе
        L.DomEvent.disableClickPropagation(el);
        L.DomEvent.disableScrollPropagation(el);
    }, []);

    // Проверяем, включены ли сейчас все фильтры
    const allActive = Object.values(activeFilters).every(v => v);
    // Убираем "panorama" из списка отображения
    const displayCategories = CATEGORIES.filter(cat => cat !== 'panorama');

    return (
        <div
            ref={carouselRef}
            className="filters-carousel"
            style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}
        >
            <div
                key="all"
                className={`filter-bubble ${allActive ? 'filter-bubble--active' : ''}`}
                onClick={resetFilters}
            >
                <span className="filter-bubble__label">Показать всё</span>
            </div>

            {displayCategories.map(category => (
                <div
                    key={category}
                    className={`filter-bubble ${!allActive && activeFilters[category] ? 'filter-bubble--active' : ''}`}
                    onClick={() => selectFilter(category)}
                >
                    <img
                        src={categoryIconMap[category]}
                        alt={categoryNameMap[category]}
                        className="filter-bubble__icon"
                    />
                    <span className="filter-bubble__label">
            {categoryNameMap[category]}
          </span>
                </div>
            ))}
        </div>
    );
};

export default FiltersCarousel;
